module.exports = __webpack_public_path__ + "img/tw-i.14bf5b8c.svg";